module.exports = __webpack_public_path__ + "images/price-index-blue-2225f6d0.svg";